import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PoFilterCriteria from './PoFilterCriteria'
import PoList from './PoList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PoAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPoDashboardPoList } from '../../store/slice/PharmaSlice';

export default function PoListView({setShowEdit,setPoId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.poDashboard);   

    const [filteredPoList, setFilteredPoList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { poDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (poDashboard.poList.length>-1){
        setFilteredPoList(poDashboard.poList);
        transformToCardFormat(poDashboard.poList, setCardList);
      }
    },[poDashboard.poList])

    useEffect(()=>{
          transformToCardFormat(filteredPoList, setCardList);
      },[filteredPoList])

    useEffect(()=>{
        if (filterCriteria.podate==='' && filterCriteria.partyname==='' && filterCriteria.povalue==='' && filterCriteria.ordervalue==='' ){
            setFilteredPoList(poDashboard.poList);
            transformToCardFormat(poDashboard.poList, setCardList);

        } else {
            setFilteredPoList(
                poDashboard.poList
                    .filter(po=> po.podate.toString().toUpperCase().includes(filterCriteria.podate.toString().toUpperCase()))
.filter(po=> po.partyname.toString().toUpperCase().includes(filterCriteria.partyname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(poDashboard.filteredPoList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PoList
                    setShowEdit={setShowEdit}
                    setPoId = {setPoId}
                    tableList={filteredPoList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}